export class ModulesRoutingNames {
    public static readonly NAME_BASE = '';

    public static readonly ROUTE_BASE = `/${ModulesRoutingNames.NAME_BASE}`;
}
